import {
  ApiResponse,
  appointmentsBaseUrl,
  getData,
} from "@Services/constServices";

export const getAppointmentById_service = async (
  id: number
): Promise<ApiResponse> => {
  // Usar endpoint v2: /detail en lugar de /Reserva/GetOneReservation
  const url = `${appointmentsBaseUrl}/detail?reserveId=${id}`;
  const successMessage = "Reserva encontrada correctamente.";
  const errorMessage =
    "Hubo un error al obtener la reserva, intente nuevamente.";
  return getData(url, successMessage, errorMessage);
};
